module.exports = __webpack_public_path__ + "static/after_drop_bottle-6f25a604626b953c8399bd3b5a28ac51.mp4";